import BasicCard from "../../../components/basics/cards/BasicCard";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import UploadActions from "./UploadActions";
import UploadInformation from "./UploadInformation";
import UploadTask from "./UploadTask";
import './upload.css'
import { useEffect, useState } from 'react';
import { UploadAPIService } from "../../../services/apis/UploadAPIService";

function Upload({ source, pageTitle }) {
    const [refreshSource, setrefreshSource] = useState([]);
    const [properties, setProperties] = useState([]);
     useEffect(() => {
        console.log(properties);
         UploadAPIService.get(source).then(data => {
             setProperties(data);
             setrefreshSource(source)
          
         });

    }, []);

    return (
        <BasicCard cardConfig={{ cardTitle: pageTitle, cardHeadingElement: 'h4' }}>
            <portal-flexbox-tile className="hydrated">
                {properties?.configurationId != null  && (
                    <Row md={1} lg={3}>
                        <Col>
                            <UploadInformation source={properties.source} lastRunDate={properties.lastRunDate} lastRunFile={properties.lastRunFile} lastRunUser={properties.lastRunUser} lastRunResult={properties.lastProcessId} lastSuccesFulDate={properties.lastSuccesFulDate} succesFulRunfile={properties.lastSuccesFulRunFile } />
                        </Col>
                        <Col>
                            <UploadActions refreshSource={refreshSource} />
                        </Col>
                        <Col>
                            <UploadTask refreshSource={properties.source}  setrefreshSource={setrefreshSource}  />
                        </Col>
                    </Row>
                )}
            </portal-flexbox-tile>
        </BasicCard>
    );
}

export default Upload;